import { render, staticRenderFns } from "./MedicalResumeForm.vue?vue&type=template&id=707b55b4&scoped=true"
import script from "./MedicalResumeForm.vue?vue&type=script&lang=js"
export * from "./MedicalResumeForm.vue?vue&type=script&lang=js"
import style0 from "./MedicalResumeForm.vue?vue&type=style&index=0&id=707b55b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b55b4",
  null
  
)

export default component.exports